module.exports = __webpack_public_path__ + "static/frame-f1d76b0640cdc983c0afdc65a9600e96.png";